// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bcj_a bic_a bic_q bic_j bic_wl bic_bj","ImgResponsive__img":"bcj_b bic_b bic_ql"};